var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconSortComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'arco';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-sort").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 16", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { d: "M1.59739 5.58428C1.46721 5.71446 1.46721 5.92552 1.59739 6.0557L2.0688 6.52711C2.19898 6.65729 2.41004 6.65729 2.54022 6.52711L5.66652 3.40081 5.66652 14.2916C5.66652 14.4757 5.81576 14.6249 5.99986 14.6249L6.66655 14.6249C6.85064 14.6249 6.99989 14.4757 6.99989 14.2916L6.99989 1.7913C6.99989 1.52165 6.83745 1.27855 6.58833 1.17536 6.33921 1.07217 6.05246 1.12921 5.86179 1.31988L1.59739 5.58428zM14.4024 10.3319C14.5326 10.2018 14.5326 9.9907 14.4024 9.86052L13.931 9.38911C13.8008 9.25893 13.5898 9.25893 13.4596 9.38911L10.3333 12.5154 10.3333 1.62462C10.3333 1.44053 10.1841 1.29129 9.99996 1.29129L9.33328 1.29129C9.14918 1.29129 8.99993 1.44053 8.99993 1.62463L8.99993 14.1249C8.99993 14.3946 9.16237 14.6377 9.41149 14.7409 9.66061 14.844 9.94736 14.787 10.138 14.5963L14.4024 10.3319z", fillOpacity: "1" }));
}
var IconSort = React.forwardRef(IconSortComponent);
export default IconSort;
